import { Type } from 'class-transformer';
import { BoardApprovalParameterDto } from './board-approval-parameter-dto';

export class BoardApprovalsActionParametersDto {
    isClosed: boolean;
    communityId: number;

    @Type(() => BoardApprovalParameterDto)
    boardApprovalData: Array<BoardApprovalParameterDto>;
}
